import { createError } from '@common/neo.tax';
import { useParams } from 'react-router-dom';

export const useAscProjectId = (): string => {
  const { ascProjectId } = useParams();
  if (!ascProjectId) {
    throw createError('UseAscProjectIdError', 'Empty asc project id when using useAscProjectId hook');
  }
  return ascProjectId;
};

// Only use this in a route where asc project id is not required
export const useAscProjectIdOptional = (): string | null => {
  const { ascProjectId } = useParams();
  return ascProjectId ?? null;
};
